import { RootState } from "@store";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { MTFiltersValuesI } from "@services/getMinerList";

const makeSelector = () => (store: RootState) => store.filters;

export const useMTFilters = () => {
  const selector = makeSelector();
  const reselect = createSelector(selector, (filters) => filters.MT_FILTERS);
  return useSelector(reselect);
};

export const useCurrentFilter = (
  key: keyof Omit<MTFiltersValuesI, "search">
) => {
  const selector = makeSelector();
  const currentFilter = createSelector(
    selector,
    (filters) => filters.MT_FILTERS.values?.[key]
  );
  return useSelector(currentFilter);
};
